
const Status = (props) => {
    return (
        <>
            {props.value && (props.value == true || props.value.toLowerCase() == 'true' || props.value.toLowerCase() == 'active') ? 'Active' : 'Inactive'}
        </>
    )
}

export default Status